<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ServiceForm @submit-requested="submitRequested"></ServiceForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ServiceForm from '@/views/Services/ServiceForm.vue'

  export default {
  components: { ServiceForm },
  methods: {
    ...mapActions('services', ['postService']),
    submitRequested (input) {
      this.postService(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 